import { decrypt } from "./Utils/utils";

// const en = encrypt(
//   "https://ctruht0.blob.core.windows.net/twod-threed-mapped-image/Anime_bedroom.glb"
// );
// console.log(en);

// Handles loading the events for <model-viewer>'s slotted progress bar
const onProgress = (event) => {
  const progressBar = event.target.querySelector(".progress-bar");
  const updatingBar = event.target.querySelector(".update-bar");
  const button = event.target.querySelector("#ar-button");
  const body = document.querySelector("body");
  const logo = event.target.querySelector(".logo");
  body.style.background =
    "linear-gradient(0deg, rgba(227, 182, 133, 0.02) 0%, rgba(227, 182, 133, 0.02) 100%), rgba(0, 0, 0, 0.80)";
  body.style.backdropFilter = "blur(16px)";
  button.style.display = "none";
  if (event.detail.totalProgress === 0) {
    progressBar.style.display = "block";
    updatingBar.style.width = "0%";
    logo.style.display = "block";
  } else {
    updatingBar.style.width = `${event.detail.totalProgress * 100}%`;
    if (event.detail.totalProgress === 1) {
      progressBar.style.display = "none";
      body.style.background = "none";
      button.style.display = "block";
      logo.style.display = "none";
    }
  }
};

try {
  const urlParams = new URLSearchParams(window.location.search);
  const idFromUrl = urlParams.get("id")?.split(" ")?.join("+");
  const glb = decrypt(idFromUrl);
  const viewer = document.getElementById("viewer");
  viewer.src = glb;
  document.querySelector("#viewer").addEventListener("progress", onProgress);
} catch (error) {
  console.error(error);
  const viewer = document.getElementById("viewer");
  viewer.style.display = "none";
  const h2 = document.createElement("h2");
  const body = document.querySelector("body");
  h2.textContent = "Oops! could not load the GLB. Something went wrong.";
  body.append(h2);
}
